import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { adminLogin } from "../lib/api";
import { toast } from "sonner";
import { Hammer, Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@cashbidroofing.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem("cbr_admin_token", res.token);
      localStorage.setItem("cbr_admin_email", res.email);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--bg)" }} data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8" data-testid="back-to-site-link">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: "var(--fg)" }}>
            <Hammer className="w-5 h-5 text-white" />
          </div>
          <span className="font-display text-xl font-semibold tracking-tight">Cash Bid Roofing</span>
        </Link>
        <div className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-lg bg-amber-100 text-amber-700 flex items-center justify-center">
              <Lock className="w-5 h-5" />
            </div>
            <div>
              <h1 className="font-display text-2xl font-semibold tracking-tight">Admin sign-in</h1>
              <p className="text-sm text-slate-500">Cash Bid CRM</p>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full px-4 py-3 rounded-lg border border-slate-200 bg-white focus:ring-2 focus:ring-amber-500 focus:outline-none"
                required
                data-testid="admin-email-input"
              />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full px-4 py-3 rounded-lg border border-slate-200 bg-white focus:ring-2 focus:ring-amber-500 focus:outline-none"
                required
                data-testid="admin-password-input"
              />
            </div>
            <button type="submit" disabled={loading} className="btn-amber w-full" data-testid="admin-login-submit">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
